import { render, staticRenderFns } from "./Ploomes.container.vue?vue&type=template&id=30d72f12&"
import script from "./Ploomes.container.vue?vue&type=script&lang=ts&"
export * from "./Ploomes.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports